import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef } from "react";

import RadioGroupComponent from "@/app/components/ui/RadioGroup";
import { PRIMARY_BUTTON, SECONDARY_BUTTON } from "@/constants";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";

export interface INew_membership {
  new_membership: string;
}
const ModalForMembershipEdit = ({ open, setOpen, membershipId }) => {
  const cancelButtonRef = useRef(null);
  const navigate = useNavigate();

  const formHook = useForm<INew_membership>({
    mode: "onChange",
    defaultValues: {
      new_membership: "only_new_membership",
    },
  });

  const handelClick = () => {
    navigate(
      `/app/membership-setup/membership-creation?page_step=general_details&&membership_id=${membershipId}&&membership_applicable=${formHook.watch("new_membership")}`,
    );
  };
  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => setOpen(false)}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block  align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-2xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="flex items-center justify-between">
                    <h3 className="text-sm text-[#000] font-medium mb-1 flex justify-between pt-2">
                      Please select applicability condition upon edit of this membership.
                    </h3>
                    <span className="flex justify-end ml-6 cursor-pointer" onClick={() => setOpen(false)}>
                      <XMarkIcon className="h-5 w-5" />
                    </span>
                  </div>
                  <div className="py-3">
                    <hr />
                  </div>

                  <RadioGroupComponent
                    alignment="horizontal"
                    errorMessages={[]}
                    fieldError={formHook.formState.errors.new_membership}
                    register={formHook.register("new_membership")}
                    groupOptions={[
                      {
                        id: "only_new_membership",
                        title: "Apply on new members only",
                        colorClassName: "text-green-500",
                      },
                      {
                        id: "only_old_membership",
                        title: "Apply on new and existing members",
                        colorClassName: "text-red-500",
                      },
                    ]}
                    defaultSelectedId={formHook.watch("new_membership")}
                    onRadioChange={(optionId: string) => {
                      formHook.setValue(`new_membership`, optionId as "only_new_membership" | "only_old_membership");
                    }}
                    radioOptionClassName="text-sm"
                  />
                </div>
                <div className="flex items-center gap-4 justify-end p-4">
                  <button
                    type="button"
                    onClick={() => setOpen(false)}
                    className={`${SECONDARY_BUTTON} mt-3 w-full sm:mt-0 sm:w-auto`}
                  >
                    Cancel
                  </button>
                  <button onClick={handelClick} className={`${PRIMARY_BUTTON} mt-3 w-full sm:mt-0 sm:w-auto`}>
                    Edit
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default ModalForMembershipEdit;
